import styled from 'styled-components'
import { COLOR } from '../../assets/constants/constants'

export const ContainerFeatureList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: auto;

  @media (min-width: 768px) {
    padding-right: 60px;
  }
`

export const ItensDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  img {
    margin-right: 20px;
    width: 30px;
    height: 30px;
  }
  padding: 26px 0 6px 0;
`;

export const StyledButton = styled.div`
  cursor: pointer;
  border: 1px solid #fff;
  color: #fff;
  width: 154px;
  height: 38px;
  text-align: center;
  padding: 8px 10px;
  font-size: 14px;
  text-transform: uppercase;
  margin-top: 20px;

  a {
    text-decoration: none;
    color: #fff;
  }

  :hover {
    color: ${COLOR.quaternary};
  }

  @media (max-width: 600px) {
    margin-top: 0;
    position: absolute;
    right: 40px;
    grid-row: 1;
  }
`;